import { render } from "./JavaScript.vue?vue&type=template&id=573edf64&scoped=true"
import script from "./JavaScript.vue?vue&type=script&lang=js"
export * from "./JavaScript.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-573edf64"

export default script